class AssetQueue {
  #queue = [];
  #currentJob = null;

  async #consumeNext() {
    if (this.#queue.length > 0) {
      // Get the next job in queue
      const job = this.#queue.shift();

      // Run the job
      this.#currentJob = job.method(
        job.uid,
        job.files,
        job.ignoreFolder,
        job.assetsPath
      );

      await this.#currentJob;

      // Start next loader
      await this.#consumeNext();
    } else {
      this.#currentJob = null;
    }
  }

  append(method, uid, files, ignoreFolder, assetsPath) {
    // Add the job to the queue
    this.#queue.push({ method, uid, files, ignoreFolder, assetsPath });

    // If there's no job currently running, we can start right away
    if (!this.#currentJob) {
      this.#consumeNext().catch((err) => console.error(err));
    }
  }
}

const assetQueue = new AssetQueue();
export { assetQueue, AssetQueue };
